import { configureStore } from '@reduxjs/toolkit';

import userReducer from './../../components/UserStore';
import coursesReducer from './../../components/CoursesStore';
import authReducer from './../../components/AuthStore';
import answerStore from 'views/StudentExamTHPT2025/answerStore';

export default configureStore({
  reducer: {
    user: userReducer,
    answer: answerStore,
    courses: coursesReducer,
    auth: authReducer
  }
});
